import { Component, OnInit } from '@angular/core';
import { ApsServiceService } from '../aps-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, ActivationEnd,  Router,  } from '@angular/router';
@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css']
})
export class EventsComponent implements OnInit {
  loaderdata:any=false
  dataexist:any=false
  data:any=''
  pages:any=''
  next:any=''
  previous:any=''
  first:any=""
  last:any=""
  limit:any=4
  eventspage:any='';
  eventpagenumber:any



  constructor(private routepage:Router,private route: ActivatedRoute,private searchitem: ApsServiceService,private sanitizer:DomSanitizer,private router: Router) { }
  ngOnInit(): void {
    
    this.geeventlist();

    this.router.events.subscribe(event =>{
      //console.log(event)
      //  this.geeventlist();

      if (event instanceof ActivationEnd){
   		//console.log("navigation start");
       this.geeventlist();
      }
    })
    
  }


  geeventlist(){
    this.data=[]
    this.loaderdata=true;
    this.eventpagenumber = this.route.snapshot.params.page;
    //console.log(this.eventpagenumber)
    //console.log(this.route.snapshot.params.eventname)
    this.eventspage=this.route.snapshot.params.eventname
    if(this.eventspage=="past"){
    this.searchitem.pastevent(this.eventpagenumber,this.limit).subscribe((responce) => {
      if(responce.status){
        this.dataexist=true
      this.pages=parseInt(responce.totalitems)
      this.last=Math.ceil(this.pages/this.limit)

      if(responce.next){
        this.next=parseInt(responce.next)

      }else{
        //console.log("else statement")
        this.next=0
      }
      if(responce.previous){
        this.previous=parseInt(responce.previous)
      }else{
        //console.log("else statement")
        this.previous=0
      }

      //console.log(responce.totalitems)
    //  this.data = this.sanitizer.bypassSecurityTrustHtml(responce.data[0].event_details);  
    this.data=responce.data
  }else{
    this.dataexist=false

  }
  this.loaderdata=false;
    })
  }else if(this.eventspage=="future"){
    this.searchitem.futureevent(this.eventpagenumber,this.limit).subscribe((responce) => {
      if(responce.status){
        this.dataexist=true
      this.pages=parseInt(responce.totalitems)
      this.last=Math.ceil(this.pages/this.limit)

      if(responce.next){
        this.next=parseInt(responce.next)

      }else{
        //console.log("else statement")
        this.next=0
      }
      if(responce.previous){
        this.previous=parseInt(responce.previous)
      }else{
        //console.log("else statement")
        this.previous=0
      }

      //console.log(responce.totalitems)
    //  this.data = this.sanitizer.bypassSecurityTrustHtml(responce.data[0].event_details);  
    this.data=responce.data
  }else{
    this.dataexist=false;
  }
  this.loaderdata=false;
    })
  }else{
    this.routepage.navigate(['/']);
    this.loaderdata=false
  }

    
  }

}
